import { GET_LOCATION_AND_IP } from "./types";
const initialState = {
  latitude: null,
  longitude: null,
  ip: null,
  permissionGranted: false,
};

const userIpAddReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LOCATION_AND_IP:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

export default userIpAddReducer;
